var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.163,
    height: 17.539,
    viewBox: "0 0 18.163 17.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.615,
    y1: 0.085,
    x2: 0.126,
    y2: 0.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#454341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#383534"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.651,
    y1: 0.255,
    x2: 0.439,
    y2: 0.599,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282726"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75988",
    "data-name": "Group 75988",
    transform: "translate(-70.274 -129.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75987",
    "data-name": "Group 75987",
    transform: "translate(70.274 129.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75986",
    "data-name": "Group 75986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82744",
    "data-name": "Path 82744",
    d: "M94.064,140.491a11.315,11.315,0,0,1-5.044,8.945c-1.771,1.052-3.348.949-4.295-.07l-4.535-4.88c.685.737,1.826.811,3.107.05a8.186,8.186,0,0,0,3.649-6.471c-.022-1.433-.656-2.335-1.612-2.548l6.5,1.451C93.157,137.262,94.034,138.51,94.064,140.491Z",
    transform: "translate(-76.378 -133.254)",
    fill: "#282726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82745",
    "data-name": "Path 82745",
    d: "M81.763,145.5q.261.265.525.524a5.283,5.283,0,0,0,.931-.442,10.008,10.008,0,0,0,4.462-7.912,4.916,4.916,0,0,0-.137-1.114c-1.315-.547-2.622-1.116-3.933-1.69a5.587,5.587,0,0,0-.55.286,10.059,10.059,0,0,0-4.455,7.663A19.11,19.11,0,0,1,81.763,145.5Z",
    transform: "translate(-75.402 -132.855)",
    fill: "#d81906"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75985",
    "data-name": "Group 75985",
    transform: "translate(6.506 5.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82746",
    "data-name": "Path 82746",
    d: "M101.15,154.247a1.1,1.1,0,0,0-.488.866c.005.316.231.439.506.276a1.1,1.1,0,0,0,.488-.866C101.651,154.207,101.425,154.084,101.15,154.247Z",
    transform: "translate(-95.486 -149.913)",
    fill: "#702424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82747",
    "data-name": "Path 82747",
    d: "M101.943,154.3a1.281,1.281,0,0,1-.134.554,1.42,1.42,0,0,1-.52.605.751.751,0,0,1-.134.064c-.3.109-.538-.063-.543-.433a.958.958,0,0,1,.006-.123l.017-.155a.754.754,0,0,0,0,.092c0,.276.178.405.406.323a.571.571,0,0,0,.1-.048,1.059,1.059,0,0,0,.388-.452.958.958,0,0,0,.1-.414c0-.315-.231-.439-.506-.276l.146-.108C101.633,153.71,101.937,153.875,101.943,154.3Z",
    transform: "translate(-95.455 -149.701)",
    fill: "#7d2828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82748",
    "data-name": "Path 82748",
    d: "M91.26,143.342l3.161,2.584a1.221,1.221,0,0,0-1.432.061A4.012,4.012,0,0,0,91.2,149.16a1.2,1.2,0,0,0,.67,1.214l-3.827-1.424a1.511,1.511,0,0,1-.845-1.53,5.059,5.059,0,0,1,2.255-4A1.54,1.54,0,0,1,91.26,143.342Z",
    transform: "translate(-87.198 -143.087)",
    fill: "#d81906"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82749",
    "data-name": "Path 82749",
    d: "M99.4,150.21a4.012,4.012,0,0,0-1.789,3.172c.018,1.155.847,1.607,1.852,1.01a4.012,4.012,0,0,0,1.789-3.172C101.231,150.065,100.4,149.613,99.4,150.21Zm.7,1.7a1.467,1.467,0,0,1-.654,1.159c-.368.218-.67.053-.677-.369a1.467,1.467,0,0,1,.654-1.159C99.784,151.319,100.087,151.484,100.093,151.906Z",
    transform: "translate(-93.606 -147.31)",
    fill: "#ff2610"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82750",
    "data-name": "Path 82750",
    d: "M82.729,133.473a12.365,12.365,0,0,0-5.512,9.774,4.122,4.122,0,0,0,1.38,3.366c-1.238-.934-1.011-1.817-7.264-6.29a3.158,3.158,0,0,1-1.058-2.58,9.476,9.476,0,0,1,4.224-7.49,3.223,3.223,0,0,1,2.869-.451c7.019,3.138,7.673,2.485,9.1,3.083A4.2,4.2,0,0,0,82.729,133.473Z",
    transform: "translate(-70.274 -129.631)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82751",
    "data-name": "Path 82751",
    d: "M77.218,156.236l-6.942-5.5a3.158,3.158,0,0,0,1.058,2.58c6.252,4.474,6.026,5.357,7.264,6.29A4.122,4.122,0,0,1,77.218,156.236Z",
    transform: "translate(-70.275 -142.62)",
    opacity: 0.9,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82752",
    "data-name": "Path 82752",
    d: "M93.844,138.326a12.365,12.365,0,0,0-5.512,9.774c.054,3.558,2.61,4.951,5.708,3.112a12.364,12.364,0,0,0,5.512-9.774C99.5,137.88,96.942,136.487,93.844,138.326Zm5.232,3.394a11.315,11.315,0,0,1-5.044,8.945c-2.836,1.684-5.174.409-5.224-2.847a11.315,11.315,0,0,1,5.044-8.945C96.687,137.189,99.026,138.464,99.076,141.721Z",
    transform: "translate(-81.389 -134.484)",
    fill: "#383534"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/AlarmIcon.e7255cfeb5900c442c84c79486bb760c.svg";
export { ForwardRef as ReactComponent };